import { render, staticRenderFns } from "./modalNF.vue?vue&type=template&id=5e84dfd3&scoped=true&"
import script from "./modalNF.vue?vue&type=script&lang=js&"
export * from "./modalNF.vue?vue&type=script&lang=js&"
import style0 from "./modalNF.vue?vue&type=style&index=0&id=5e84dfd3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e84dfd3",
  null
  
)

export default component.exports